// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__tn+aF","moreInfo":"TopMenu_moreInfo__cSOb5","logo":"TopMenu_logo__TEl3T","menuTrigger":"TopMenu_menuTrigger__8Ur0-","closed":"TopMenu_closed__tYaZj"};